import './Organizations.css';
import { IconPin, IconGlobe } from '../components/Icons';
import { 
  LogoUGM, LogoGlobethics, LogoYadema, LogoYKPAI, LogoEcoVillage 
} from '../components/PartnerLogos';
import useScrollReveal from '../hooks/useScrollReveal';

const orgs = [
  {
    id: 1,
    Logo: LogoUGM,
    color: '#003399',
    name:  'Universitas Gadjah Mada',
    abbr:  'UGM',
    role:  'Associate Professor, Graduate School of Inter-Religious Studies (IRS)',
    since: '',
    website: 'https://ugm.ac.id',
    location: 'Yogyakarta, Indonesia',
    description: null,
    responsibilities: [],
  },
  {
    id: 2,
    Logo: LogoGlobethics,
    color: '#1b4332',
    name:  'Globethics',
    abbr:  'Globethics',
    role:  'Vice President',
    since: '',
    website: 'https://globethics.net',
    location: 'Geneva, Switzerland',
    description: null,
    responsibilities: [],
  },
  {
    id: 3,
    Logo: LogoYadema,
    color: '#7c3aed',
    name:  'Yayasan Dharma Etika Mandiri',
    abbr:  'Yadema',
    role:  'Founder and President of the Board',
    since: '',
    website: 'https://yadema.org',
    location: 'Yogyakarta, Indonesia',
    description: null,
    responsibilities: [],
  },
  {
    id: 4,
    Logo: LogoYKPAI,
    color: '#c9a96e',
    name:  'Yayasan Kerjasama Perdamaian dan Akademik Indonesia',
    abbr:  'YKPAI',
    role:  'Founder and President of the Board',
    since: '',
    website: 'https://ykpai.org',
    location: 'Yogyakarta, Indonesia',
    description: null,
    responsibilities: [],
  },
  {
    id: 5,
    Logo:  LogoEcoVillage,
    color: '#047857',
    name:  'Nglanggeran Eco-Village',
    abbr:  'Nglanggeran Eco-village',
    role:  'CEO, Designer and Curator',
    since: '',
    website: 'https://eco-village.nglanggeran.com',
    location: 'Gunung Kidul, Yogyakarta',
    description: null,
    responsibilities: [],
  },
];

export default function Organizations() {
  useScrollReveal();
  return (
    <main>
      <section className="page-hero" aria-labelledby="orgs-heading">
        <div className="container reveal reveal-up">
          <span className="section-label">Vice President & Institutional Roles</span>
          <h1 id="orgs-heading">Organizations</h1>
          <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.75)' }}>
            Institutional roles spanning academic excellence, international ethics networks, and global vice presidency across four continents.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {orgs.map((org, i) => (
            <article key={org.id} id={`org-${org.id}`} className={`org-card ${i % 2 === 1 ? 'org-card--reverse' : ''} reveal reveal-up delay-${(i % 3) + 1}`}>
              <div className="org-card__accent" style={{ background: org.color }}>
                <div className="org-card__logo-circle">
                  {org.Logo ? <org.Logo size={80} /> : <span className="org-card__logo-text">{org.logo}</span>}
                </div>
                <span className="org-card__abbr">{org.abbr}</span>
                {org.since && (
                  <div className="org-card__since">
                    <span>Since</span>
                    <strong>{org.since}</strong>
                  </div>
                )}
              </div>
              <div className="org-card__content">
                <div className="org-card__header">
                  <div>
                    <h2 className="org-card__name">{org.name}</h2>
                    <p className="org-card__role">{org.role}</p>
                    <div className="org-card__meta">
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}><IconPin size={16} /> {org.location}</span>
                      {org.website && (
                        <a href={org.website} target="_blank" rel="noopener noreferrer" className="org-card__link" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
                          <IconGlobe size={16} /> {org.website.replace('https://', '')}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
                {org.description && <p className="org-card__desc">{org.description}</p>}
                {org.responsibilities && org.responsibilities.length > 0 && (
                  <div className="org-card__responsibilities">
                    <h4>Key Responsibilities</h4>
                    <ul>
                      {org.responsibilities.map(r => <li key={r}>{r}</li>)}
                    </ul>
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
